import { createFileRoute, redirect } from "@tanstack/react-router";
import ProfileModule from "@/modules/ProfileModule";
import { useAuthStore } from "@/stores/useAuth";

export const Route = createFileRoute("/_default/profile")({
  component: RouteComponent,
  beforeLoad: () => {
    const { currentUser } = useAuthStore.getState();
    if (!currentUser?.id || currentUser.providers.length === 0) {
      throw redirect({ to: "/" });
    }
  },
});

function RouteComponent() {
  return <ProfileModule />;
}
